export default __webpack_public_path__ + "static/media/devsigner.6d9b9d6a.svg";